/**
 * Check if a SweetAlert2 modal/drawer (toasts excluded) or an off-canvas drawer is open.
 * Their scroll lock fires scroll events that sticky elements must ignore.
 * @returns {boolean}
 */
function isOverlayOpen() {
	const bodyClasses = document.body.classList;
	const isSwalOpen = bodyClasses.contains('swal2-shown') && !bodyClasses.contains('swal2-toast-shown');

	return isSwalOpen || document.documentElement.classList.contains('is-drawer-open');
}

module.exports = isOverlayOpen;
